import React, { FC, Fragment, useState } from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import MillingJobsPageActions from 'components/milling-jobs/milling-jobs-page-actions.component';
import MillingJobsTodoList from 'components/milling-jobs/milling-jobs-todo/milling-jobs-todo-list.component';
import MillingBatchesList from 'components/milling-jobs/milling-batches/milling-batches-list.component';
import { MillingFilters } from 'models/milling';

const Milling: FC = () => {
    const { t: translate } = useTranslation(['milling-jobs']);
    const [showSets, setShowSets] = useState(false);
    const [filters, setFilters] = useState<MillingFilters>({});

    return (
        <Fragment>
            <Helmet>
                <title>{translate('milling-jobs:MILLING_JOBS')} | Denthub</title>
            </Helmet>

            <Box mb={2}>
                <MillingJobsPageActions
                    onFilterChange={(newFilter) => setFilters(newFilter)}
                    onToggleShowSets={(newValue) => setShowSets(newValue)}
                />
            </Box>
            {showSets ? <MillingBatchesList filters={filters} /> : <MillingJobsTodoList filters={filters} />}
        </Fragment>
    );
};

export default Milling;
